'use client';
import { createContext, PropsWithChildren } from 'react';

import { PageNavigationData } from '@/types/ssr';

type PageNavigationCtxProps = PropsWithChildren<{ pageNavigationData?: PageNavigationData }>;

export const PageNavigationContext = createContext<PageNavigationData | null>(null);

export function PageNavigationProvider({ children, pageNavigationData }: PageNavigationCtxProps) {
  return <PageNavigationContext.Provider value={pageNavigationData || null}>{children}</PageNavigationContext.Provider>;
}
